<template>
	<div id="app">
		<LanguageSwitcher v-if="false" />
	<router-view />
	</div>
</template>

<script setup>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { defineExpose, onMounted, provide, ref } from "vue";
const isDarkMode = ref(false);

const toggleTheme = () => {
	isDarkMode.value = !isDarkMode.value;
	document.documentElement.setAttribute("data-theme", isDarkMode.value ? "dark" : "light");
	localStorage.setItem("theme", isDarkMode.value ? "dark" : "light");
};

// Provide theme control to child components
provide("themeControl", {
	toggleTheme,
	isDarkMode,
});

onMounted(() => {
	// Load theme preference from localStorage
	const savedTheme = localStorage.getItem("theme") || "light";
	isDarkMode.value = savedTheme === "dark";
	document.documentElement.setAttribute("data-theme", savedTheme);
});

// Expose theme toggle function to other components
defineExpose({ toggleTheme, isDarkMode });
</script>

<script>
export default {
	name: "App",
	mounted() {
		// Update favicon
		/*
	  const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
	  link.type = 'image/svg+xml';
	  link.rel = 'icon';
	  link.href = '/favicon.svg';
	  document.getElementsByTagName('head')[0].appendChild(link);
	  */
	},
};
</script>
